export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-social-youtube-12b389e6d94b3f44197327f358f0892a.svg";